import React from "react";
import styled from "styled-components";
import { RadioBox } from "@vds/radio-boxes";
import { Body } from "@vds/typography";

const RadioBoxSection = ({
  data,
  selected,
  onChange,
  compactView,
  isStickyButton,
  handleAutoScroll = () => {},
  scrollItemId = "",
  ...props
}) => {
  return (
    <SectionContainer isStickyButton={isStickyButton}>
      <RadioBoxContainer>
        {data?.map((item) => {
          return (
            <AutoScroll onClick={() => handleAutoScroll(scrollItemId)}>
              <StyledRadioBox
                key={item?.id}
                selected={item?.id === selected}
                onChange={() => onChange(item?.id)}
                name={item?.title}
                value={item?.id}
                outOfStock={item?.outOfStock}
                disabled={item?.outOfStock}
                children={
                  <>
                    <Body
                      bold
                      size="large"
                      color={item?.outOfStock ? "#D8DADA" : "#000000"}
                    >
                      {item?.title}
                    </Body>
                    <Body
                      size="large"
                      color={item?.outOfStock ? "#D8DADA" : "#000000"}
                    >
                      {item?.subtitle}
                    </Body>
                  </>
                }
                compactView={compactView}
              />
            </AutoScroll>
          );
        })}
      </RadioBoxContainer>
    </SectionContainer>
  );
};

const SectionContainer = styled.div`
  margin: 1rem 0 1.5rem 0;
  .device-info {
    display: inline-block;
    margin-bottom: 0.5rem !important;
  }
     ${({isStickyButton}) => isStickyButton && 
     `z-index:: 0 !important;
     position:sticky `
    }
  
`;
const RadioBoxContainer = styled.div`
  margin-bottom: -2rem !important;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  margin-top: 1rem;
  max-width: 596px;
  margin-left: 3px;
  @media screen and (min-width: 230px) and (max-width: 767px) {
    margin-left: 0px;
  }
`;

const AutoScroll = styled.div`
  flex: 1;
  min-height: ${({ compactView }) => (compactView ? "0" : "2rem")};
  margin: 5px 12px 17px 0;
   @media screen and (min-width: 230px) and (max-width: 767px) {
    display: flex;
    flex: 2 1 auto;
    width: 328px;
    margin: 5px 1px 12px 0;
    max-width: 100%;
  }
`;

const StyledRadioBox = styled(RadioBox)`
`;



export default React.memo(RadioBoxSection);
